<template>
  <div class="form-group" :class="{ required, 'has-error': !!error, [$attrs.class]: !!$attrs.class }">
    <label :for="name" class="form-label">{{ label }}</label>
    <input v-bind="$attrs" :id="name" ref="input" :name="name" :type="type" dir="auto" :required="required"
      :value="value" :class="{
        'form-control': type != 'file',
        [inputClass]: !!inputClass,
      }" @input="handleUpdate" />
    <div v-if="error" class="form-text mt-1">{{ error }}</div>
    <div v-if="help" class="form-text mute mt-1">{{ help }}</div>
  </div>
</template>
<script>
  import { useId } from "vue";

  export default {
    inheritAttrs: false,
    props: {
      inputClass: String,
      autofocus: Boolean,
      error: String,
      label: String,
      help: String,
      type: String,
      required: Boolean,
      modelValue: String,
      name: { type: String, default: () => useId() },
    },
    emits: ["update:modelValue"],
    computed: {
      value() {
        if (this.type === "date" && this.modelValue)
          return new Date(this.modelValue).toISOString().split("T")[0];
        return this.modelValue;
      },
    },
    mounted() {
      if (this.autofocus) {
        this.$refs.input?.focus();
      }
    },
    methods: {
      handleUpdate($event) {
        if (this.type === "date" && $event.target.value) {
          let dt = new Date($event.target.value);
          return this.$emit("update:modelValue", dt);
        }
        this.$emit("update:modelValue", $event.target.value);
      },
    },
  };
</script>
